import styled from 'styled-components';
import { GRUNDFOS_BLUE, BLUE1, BLUE3, ATTENTION_BLUE, GREEN3 } from '../../../constants/colors';
import { FONT_FAMILY, FONT_SIZE } from '../../../constants/fonts';
import { MEDIA } from '../../../constants/breakpoints';

export const ChatHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 14px 24px;
  background: white;
  border-bottom: 1px solid #eef1f5;
  flex-shrink: 0;
`;



export const ChatHeader__Title = styled.h1`
  color: ${GRUNDFOS_BLUE};
  font-family: ${FONT_FAMILY.BOLD};
  font-size: ${FONT_SIZE.LARGE};
  margin: 0;

  ${MEDIA.MOBILE} {
    font-size: ${FONT_SIZE.MEDIUM};
  }
`;

export const ChatHeader__SessionInfo = styled.div<{ $visible: boolean }>`
  display: flex;
  align-items: center;
  gap: 8px;
  background: ${BLUE1};
  padding: 8px 12px;
  border-radius: 20px;
  color: ${BLUE3};
  font-family: ${FONT_FAMILY.REGULAR};
  font-size: ${FONT_SIZE.SMALL};
  visibility: ${(props) => (props.$visible ? 'visible' : 'hidden')};

  ${MEDIA.MOBILE} {
    display: none;
  }
`;

export const ChatHeader__Left = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
`;

export const ChatHeader__Right = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;

  ${MEDIA.MOBILE} {
    gap: 8px;
  }
`;

export const ChatHeader__IconBtn = styled.button<{ $color?: string; $size?: string }>`
  height: ${props => props.$size === 'small' ? '34px' : '40px'};
  padding: ${props => props.$size === 'small' ? '0 14px' : '0 16px'};
  border-radius: 20px;
  border: none;
  background: ${props => props.$color ?? ATTENTION_BLUE};
  color: white;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  transition: opacity 0.15s ease, box-shadow 0.15s ease;
  font-size: ${FONT_SIZE.SMALL};
  font-family: ${FONT_FAMILY.SEMI_BOLD};
  white-space: nowrap;

  &:hover:not(:disabled) {
    opacity: 0.88;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.18);
  }

  &:disabled {
    opacity: 0.45;
    cursor: not-allowed;
  }

  ${MEDIA.MOBILE} {
    height: 38px;
    padding: 0 10px;
    font-size: 0;
    gap: 0;

    svg {
      font-size: 16px;
    }
  }
`;

export const ChatHeader__HamburgerBtn = styled.button`
  display: none;
  width: 40px;
  height: 40px;
  border-radius: 8px;
  border: none;
  background: transparent;
  color: ${GRUNDFOS_BLUE};
  cursor: pointer;
  align-items: center;
  justify-content: center;
  font-size: 20px;
  transition: background 0.2s ease;

  &:hover {
    background: ${BLUE1};
  }

  ${MEDIA.MOBILE} {
    display: flex;
  }
`;

export const ChatHeader__NewChatBtn = styled(ChatHeader__IconBtn)`
  background: ${BLUE1};
  color: ${GRUNDFOS_BLUE};

  &:hover:not(:disabled) {
    background: ${BLUE1};
    opacity: 0.8;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.12);
  }
`;

export const ChatHeader__DiagramBtn = styled(ChatHeader__IconBtn)`
  background: ${GRUNDFOS_BLUE};
`;

export const ChatHeader__ExcelBtn = styled(ChatHeader__IconBtn)`
  background: ${GREEN3};
`;

export const ChatHeader__DomainSelect = styled.select`
  height: 32px;
  min-width: 120px;
  padding: 0 10px;
  border-radius: 8px;
  border: 2px solid ${GRUNDFOS_BLUE};
  background: #ffffff;
  color: ${GRUNDFOS_BLUE};
  font-family: ${FONT_FAMILY.BOLD};
  font-size: ${FONT_SIZE.SMALL};

  &:focus {
    outline: none;
    box-shadow: 0 0 0 2px rgba(0, 74, 143, 0.2);
  }

  ${MEDIA.MOBILE} {
    min-width: 96px;
    max-width: 130px;
    height: 30px;
    padding: 0 8px;
  }
`;
